const settings = {
  ctrlSpeed: 1,
  quality: 2,
  maxZoom: 4,
  minZoom: 0.4,
  maxPolarAngle: 4,
  minPolarAngle: 0,
  autoRotate: false,
  autoRotateSpeed: 5,
  cameraTweenSpeed: 1500,
  TargetTweenSpeed: 2000,
  voiceSpeed: 1,
  voicePitch: 1,
  voiceLevel: 1,
  developmentModel: false,
};

export default settings;
